var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLong)?_c('span',{staticClass:"ink-text ink-text--plain"},[_vm._v(_vm._s(_vm.text))]):_c('span',{staticClass:"ink-text",style:(_vm.containerStyle)},_vm._l((_vm.chars),function(char,index){return _c('span',{key:index,staticClass:"ink-text__char",style:(_vm.charStyle(index))},[_vm._v(_vm._s(char))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }